import React, { useState } from 'react';
import getUserData from '../userServices/getUserData';
import isTokenStructureValid from '../authHelpers/isTokenStructureValid';
import { handleAddToCart } from '../helpers/handleAddToCart';
import { pushAddToCartEvent, pushBeginCheckoutEvent } from '../helpers/dataLayer';
import Spinner from '../Spinner';

const ProductBuytButton = ({props}) => {
  const { productSku, productPrice, productTitle, loginRedirectLink, checkoutRedirectLink } = props

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleBuyProduct = async () => {
    setIsSubmitting(true);
    setErrorMessage("");

    pushAddToCartEvent({ sku: productSku, name: productTitle, price: Number(productPrice) });
    pushBeginCheckoutEvent({ sku: productSku, name: productTitle, price: Number(productPrice) });

    const token = getUserData().token;
    const isUserDataCorrect = getUserData().isUserDataCorrect;
    if (token && isTokenStructureValid(token) && isUserDataCorrect) {
      const result = await handleAddToCart(productSku, checkoutRedirectLink, setIsSubmitting);

      if (!result.success) {
        setErrorMessage(result.errorMessage);
        setIsSubmitting(false);
      }
    } else {
      localStorage.setItem('wp_product_sku', productSku)
      window.location.href = loginRedirectLink
    }
  };

  return (
    <>
      {!!productPrice && 
        <div className='uk-margin-large-top'>
          <p className='uk-heading-large uk-margin-bottom price'>{productPrice} £</p>
          <button onClick={handleBuyProduct} disabled={isSubmitting} className='uk-button uk-button-secondary'>{isSubmitting ? <Spinner /> : 'Buy product'}</button>

          {errorMessage && (
            <p className="uk-margin-small-top uk-text-danger uk-margin-small-bottom">{errorMessage}</p>
          )}
        </div>
      }
    </>
  );
};

export default ProductBuytButton;
